import { UploadData } from '../../../../store/uploadStore';
import { declense } from '../../../../libs/declense';

export const calculateRemainingTimeSeconds = (
  bytesPerSecond: number | undefined,
  fileRegistrationTimeMs: number,
  upload: UploadData,
) => {
  if (!bytesPerSecond || bytesPerSecond <= 0) return null;
  if (!upload.meta.uploadSize) return null;

  const remainingCount = upload.overview.photosCount.all - upload.overview.photosCount.uploaded;
  const remainingSize = upload.meta.uploadSize - (upload.meta.uploadedSize ?? 0);

  const uploadTimeSeconds = remainingSize / bytesPerSecond;

  const registrationTimeSeconds = (fileRegistrationTimeMs / 1000) * remainingCount;

  return uploadTimeSeconds + registrationTimeSeconds;
};

export const formatRemainingTime = (remainingTimeSeconds: number | null) => {
  if (remainingTimeSeconds === null) {
    return 'Calculating remaining time...';
  }

  if (remainingTimeSeconds < 30) {
    return 'A few seconds left';
  }

  const minutes = Math.round(remainingTimeSeconds / 60) % 60;
  const hours = Math.floor(remainingTimeSeconds / 3600);

  if (hours === 0) {
    return declense(minutes, 'minute left', 'minutes left');
  }

  if (minutes === 0) {
    return declense(hours, 'hour left', 'hours left');
  }

  return declense(hours, 'hour ', 'hours ') + declense(minutes, 'minute left', 'minutes left');
};
